// react
import React from "react"
import { connect } from "react-redux"
// app
import Contacts from "components/person/Contacts"
import Citizenship from "components/person/Citizenship"
import OtherQualifications from "components/person/Other"

import { getPerson, putPerson } from "actions/profile/person/actions.js"
import { getContacts, postContact, deleteContact } from "actions/profile/contacts/actions.js"
import { getCitizenships, postCitizenship, deleteCitizenship } from "actions/profile/citizenship/actions.js"


class Step7 extends React.Component {
    constructor(props) {
        super()

        this.onPersonSave = person => this.props.putPerson(person)

        this.onCitizenshipAdd = citizenship => {
            citizenship.personid = props.personid
            this.props.postCitizenship(citizenship)
        }
        this.onCitizenshipRemove = id => {
            this.props.deleteCitizenship(id)
        }

        this.onContactAdd = contact => {
            contact.personid = props.personid
            this.props.postContact(contact)
        }
        this.onContactRemove = id => this.props.deleteContact(id)
    }

    componentDidMount() {
        const personid = this.props.personid

        this.props.getCitizenships(personid)
        this.props.getContacts(personid)
    }

    render() {
        return (
            <div>
                <OtherQualifications
                    person={ this.props.person }
                    onSave={ this.onPersonSave }
                />
                <Citizenship
                    data={ this.props.citizenships }
                    onSave={ this.onCitizenshipAdd }
                    onRemove={ this.onCitizenshipRemove }
                />
                <Contacts
                    data={ this.props.contacts }
                    onSave={ this.onContactAdd }
                    onRemove={ this.onContactRemove }
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        contacts: state.profile.contacts.get("data"),
        citizenships: state.profile.citizenships.get("data"),
        person: state.profile.person.get("data")
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getPerson: id => dispatch(getPerson(id)),
        putPerson: person => dispatch(putPerson(person)),

        getContacts: personid => dispatch(getContacts(personid)),
        postContact: contact => dispatch(postContact(contact)),
        deleteContact: id => dispatch(deleteContact(id)),

        getCitizenships: personid => dispatch(getCitizenships(personid)),
        postCitizenship: citizenship => dispatch(postCitizenship(citizenship)),
        deleteCitizenship: id => dispatch(deleteCitizenship(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Step7)


/** WEBPACK FOOTER **
 ** ./src/containers/Profile/Step7.js
 **/